import React from 'react';
import { MainLayout } from '../Layout/MainLayout';
import { ProtectedRoute } from '../Auth/ProtectedRoute';
import { useLoadEpisode } from '../../hooks/useLoadEpisode';

export const PresentationMode: React.FC = () => {
  const { loading, error, navigate } = useLoadEpisode();

  if (loading) {
    return (
      <ProtectedRoute>
        <div className="h-screen w-screen bg-black text-white flex items-center justify-center">
          <div className="text-xl">Chargement...</div>
        </div>
      </ProtectedRoute>
    );
  }

  if (error) {
    return (
      <ProtectedRoute>
        <div className="h-screen w-screen bg-black text-white flex items-center justify-center flex-col gap-4">
          <div className="text-xl text-red-400">{error}</div>
          <button 
            onClick={() => navigate('/episodes')}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded"
          >
            Retour aux épisodes
          </button>
        </div>
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute>
      <div className="h-screen w-screen bg-black text-white overflow-hidden">
        <MainLayout isPresentation />
      </div>
    </ProtectedRoute>
  );
};
